import { render, staticRenderFns } from "./finantial-settings-accounts-question.vue?vue&type=template&id=0dd19e5e&scoped=true&"
import script from "./finantial-settings-accounts-question.vue?vue&type=script&lang=js&"
export * from "./finantial-settings-accounts-question.vue?vue&type=script&lang=js&"
import style0 from "./finantial-settings-accounts-question.vue?vue&type=style&index=0&id=0dd19e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd19e5e",
  null
  
)

export default component.exports